"use strict";

/* Return unit m3*/
exports.createDebug = function(result){
    /*var resString = "";
    for(var i=0;i<result.meters.length;i++){
    	resString += ' x'+ (i+1) + ':' + Math.round(result.meters[i].center.x) + ', y'+ (i+1) + ':' +  Math.round(result.meters[i].center.y) + " ";
    	resString += 'p'+ (i+1) + ':' + result.meters[i].edgePoints;
    	resString += ' val'+ (i+1) + ':' + Math.round(result.meters[i].value * 1000) / 1000;
        resString += ' cr'+ (i+1) + ':' + Math.round(result.meters[i].centerOffsetRatio * 100) / 100;
    }
    resString += ' red:' + (Math.round(result.redPercentage * 1000) / 1000);
    resString += ' redTreshold:' + result.redTreshold;

    return resString;*/

    var debug = {
        symmetryRatios:getSymmetryRatios(result),
        pointerValues:getPointerValues(result),
        edgePoints:getEdgePoints(result),
        centerOffsetRatios:getCenterOffsetRatios(result),
        redPercentage:getRedPercentage(result),
        redTreshold:getRedTreshold(result),
        vectorDistance:getVectorDistance(result)
    }
    return debug;

}

exports.createSettingsString = function(result, config){
// add object to be used for settings in center
  if (config.decimals.positions.length === result.meters.length) {
    var positionsSetting = [];

    for (var i = 0; i < config.decimals.positions.length; i++) {
      positionsSetting.push(
        {
          precision:config.decimals.positions[i].precision,
          coords:{
            x:Math.round(result.meters[i].center.x),
            y:Math.round(result.meters[i].center.y)
          }
        });
    }
    result.debug.positionsSetting = JSON.stringify(positionsSetting);
  }
}



var getSymmetryRatios = function(result){
    var resString = "symmetryRatios:";
    for(var i=0;i<result.meters.length;i++){
        resString += ' sr'+ (i+1) + ': ' + Math.round(result.meters[i].symmetryRatio * 10) / 10;
    }
    return resString;
}
exports.getSymmetryRatios = getSymmetryRatios;

var getPointerValues = function(result){
    var resString = "values:";
    for(var i=0;i<result.meters.length;i++){
        resString += ' v'+ (i+1) + ': ' + Math.round(result.meters[i].value * 10) / 10;
    }
    return resString;
}
exports.getPointerValues = getPointerValues;

var getEdgePoints = function(result){
    var resString = "edgePoints:";
    for(var i=0;i<result.meters.length;i++){
        resString += ' p'+ (i+1) + ': ' + Math.round(result.meters[i].edgePoints * 10) / 10;
    }
    return resString;
}
exports.getEdgePoints = getEdgePoints;

var getCenterOffsetRatios = function(result){
    var resString = "centerOffsetRatios:";
    for(var i=0;i<result.meters.length;i++){
        resString += ' p'+ (i+1) + ': ' + Math.round(result.meters[i].centerOffsetRatio * 10) / 10;
    }
    return resString;
}
exports.getCenterOffsetRatios = getCenterOffsetRatios;

var getVectorDistance = function(result){
    var resString = "vectorDistance:";
    for(var i=0;i<result.meters.length;i++){
        resString += ' d'+ (i+1) + ': ' + Math.round(result.meters[i].distance * 10) / 10;
    }
    return resString;
}
exports.getVectorDistance = getVectorDistance;

var getRedPercentage = function(result){
    var resString = "red%: " + (Math.round(result.redPercentage * 1000) / 1000);
    return resString;
}
exports.getRedPercentage = getRedPercentage;

var getRedTreshold = function(result){
    var resString = "redTreshold: " + (Math.round(result.redTreshold * 1000) / 1000);
    return resString;
}
exports.getRedTreshold = getRedTreshold;








//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/decimalpointers/build-debug-data.js
// module id = 832
// module chunks = 0